// A wrapper around fetch(), handling errors more usefully
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper

export async function client(endpoint, isHtmlContent, { body, ...customConfig } = {}) {
	const headers = isHtmlContent ? {} : { "Content-Type": "application/json" };

	const config = {
		method: body ? "POST" : "GET",
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers
		}
	};

	if (body) {
		config.body = JSON.stringify(body);
	}

	let data;
	try {
		const response = await window.fetch(endpoint, config);
		data = isHtmlContent ? response.text() : await response.json();
		if (response.ok) {
			// Return a result object similar to Axios
			return {
				status: response.status,
				data,
				headers: response.headers,
				url: response.url
			};
		}
		throw new Error(response.statusText);
	} catch (err) {
		return Promise.reject(err.message ? err.message : data);
	}
}

client.get = function (endpoint, customConfig = {}) {
	return client(endpoint, false, { ...customConfig, method: "GET" });
};

client.getHtml = function (endpoint, customConfig = {}) {
	return client(endpoint, true, { ...customConfig, method: "GET" });
};

client.post = function (endpoint, body, customConfig = {}) {
	return client(endpoint, false, { ...customConfig, body });
};
